export enum enumUserRole {
  SUPER_ADMIN = 'SuperAdministrator',
  ADMIN = 'Administrator',
  SUPPORT = 'Support',
  USER = 'ApplicationUser',
  CUSTOMS_BROKER = 'CustomsBroker',
}
